<template>
  <div>
    <PopupContactOffer v-if="showContactOfferPopup" @close="SET_SHOW_CONTACT_OFFER_POPUP(false)"/>
    <div
      class="hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
    >
      <div class="px-12">
        <p class="text-4xl text-gray-900">
          Les offres Neopass
        </p>
        <p class="mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600">
          Retrouvez ici les différents abonnements Neopass.
        </p>
      </div>
      <illustration name="Group189" class="hidden xl:block absolute right-5 xl:right-10 w-60 xl:w-72" />
    </div>

    <!-- Contenu -->
    <div class="flex flex-col mt-16 mb-16">
      <MessageHeader :message-header="messageHeader" />

      <div class="-my-2 py-2">
        <div
          class="relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table min-h-halfscreen"
        >
          <router-view />
        </div>
      </div>
    </div>
    <!-- Fin Contenu -->
  </div>
</template>

<script>
import {mapGetters, mapMutations, mapActions, mapState} from 'vuex';
import Illustration from './../../components/Illustration';
import Icon from './../../components/Icon';
import Popup from '../../components/Popup';
import PopupContactOffer from '../../components/PopupContactOffer';
import MessageHeader from '../../components/MessageHeader';

export default {
  name: 'Account',

  components:{
    MessageHeader,
    PopupContactOffer,
    Popup,
    Illustration,
    Icon,
  },

  data(){
    return{
      //
    };
  },

  mounted(){
    //
  },

  methods:{
    ...mapMutations({
      SET_TABDISPLAY: 'account/SET_TABDISPLAY',
      SET_ISADMINPAY: 'account/SET_ISADMINPAY',
      SET_INCOMPANY: 'account/SET_INCOMPANY',
      SET_MESSAGEHEADER: 'account/SET_MESSAGEHEADER',
      SET_SHOW_CONTACT_OFFER_POPUP: 'account/SET_SHOW_CONTACT_OFFER_POPUP',
      SET_SAVING: 'account/SET_SAVING',
    }),
    ...mapActions({
      save_infos: 'account/save_infos',
    }),
  },
  computed:{
    ...mapGetters({
      tab_display: 'account/tabDisplay',
      isAdminPay: 'account/isAdminPay',
      inCompany: 'account/inCompany',
      showContactOfferPopup: 'account/showContactOfferPopup',
      saving: 'account/saving',
      messageHeader: 'account/messageHeader'
    }),
    ...mapState('account', ['showContactOfferPopup', 'messageHeader'])
  }
};
</script>
